import Vue from 'vue'
import {
  liveStatsVuexMutations,
  liveStatsDefaultState,
} from '@ahaslides-product/frontend-toolkit'
import getters from './live-stats.getters'
import actions from './live-stats.actions'

export default {
  namespaced: true,
  state: liveStatsDefaultState,
  mutations: liveStatsVuexMutations(Vue),
  actions,
  getters,
}
